import 	Axios from 'axios'
import { Toast } from 'vant';
const axios = Axios.create({
  baseURL: '',
  // timeout: 6 * 1000
});
//全局loading
let loading
let loadingCount = 0
function startLoading() {
  loading = Toast.loading({
    duration: 0,
    message: '加载中...',
    forbidClick: true,
  })
}

function endLoading() {
  loading.clear()
}

function addLoading() {
  startLoading()
  loadingCount++
}

function isCloseLoading() {
      loadingCount--
  if (loadingCount == 0) {
      endLoading()
  }
}


//请求拦截
axios.interceptors.request.use(function(config) {
  const userToken = window.localStorage.getItem('AndroidToken')
  addLoading();
  if( userToken){
    let USERTOKRN = userToken.split(',')[0].split(':')[1].slice(1,-1)
    let USERtenantID = userToken.split(',')[1].split(':')[1].slice(1,-2)
    config.headers.Authorization = 'Bearer '  + USERTOKRN || '',
        config.headers['tenant-id'] = USERtenantID
  } else {
    config.headers.Authorization = 'Bearer '  + window.localStorage.getItem('CT_APP_TOKEN') || '',
        config.headers['tenant-id'] = 1
  }
  return config
}, function(error) {
  endLoading();
  loadingCount = 0
  return Promise.reject(error);
})
//响应拦截
axios.interceptors.response.use(function(response) {
  isCloseLoading();
  return response
}, function(error) {
  endLoading();
  loadingCount = 0
  Toast.fail('加载失败,请联系管理员');
  return Promise.reject(error);
})
export default axios

